import React from 'react';
import PropTypes from 'prop-types';
import { StatusBadge } from 'src/common/badges';
import { AUTHORIZATION_STATUSES } from 'src/common/Status/authorizationConstants';

const badgeProps = {
  [AUTHORIZATION_STATUSES.open]: {
    className: 'bg-dark-border-blue text-text-blue',
    label: 'Open',
  },
  [AUTHORIZATION_STATUSES.accepted]: {
    className: 'bg-dark-green text-white',
    label: 'Accepted',
  },
  [AUTHORIZATION_STATUSES.rejected]: {
    className: 'bg-red text-white',
    label: 'Rejected',
  },
  [AUTHORIZATION_STATUSES.inReview]: {
    className: 'bg-orange text-white',
    label: 'In Review',
  },
  [AUTHORIZATION_STATUSES.void]: {
    className: 'bg-action-blue text-white',
    label: 'Voided',
  },
};

const validStatuses = Object.keys(badgeProps);

const ServiceAuthorizationStatusIndicator = ({ status, autoApproved, isUpdateRequest }) => {
  if (!validStatuses.includes(status)) return '';
  const { className, label } = badgeProps[status];

  let displayLabel = label;
  if (autoApproved) {
    displayLabel = `Auto ${label}`;
  } else if (isUpdateRequest && status === AUTHORIZATION_STATUSES.accepted) {
    displayLabel = 'Updated';
  }

  return <StatusBadge className={className} label={displayLabel} />;
};

ServiceAuthorizationStatusIndicator.propTypes = {
  status: PropTypes.oneOf(validStatuses).isRequired,
  autoApproved: PropTypes.bool,
  isUpdateRequest: PropTypes.bool,
};

ServiceAuthorizationStatusIndicator.defaultProps = {
  autoApproved: false,
  isUpdateRequest: false,
};

export default ServiceAuthorizationStatusIndicator;
